import { Alert, Snackbar } from "@mui/material";
import { closeSnackbar } from "../../redux/slices/snackbarSlice";
import { useAppDispatch, useAppSelector } from "../../hooks";

const CustomSnackbar = () => {
  const dispatch = useAppDispatch();
  const { open, message, type, horizontal, vertical, autoHideDuration } =
    useAppSelector((state) => state.snackbarSlice);

  const handleClose = () => {
    dispatch(closeSnackbar());
  };

  return (
    <Snackbar
      sx={{ mt: 7 , maxWidth: { xs: "100%", sm: "100%" , md:"80%",lg:"30%"} }}
      anchorOrigin={{
        vertical: vertical ?? "top",
        horizontal: horizontal ?? "right",
      }}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={type ?? "info"}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
